// export {
//   easeIn,
//   easeOut,
//   easeInOut,
//   anticipate,
//   steps,
//   cubicBezier,
// } from "motion";
export const linear = (x) => x;
//# sourceMappingURL=easing-functions.js.map